/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'lock': {
    width: 19,
    height: 25,
    viewBox: '0 0 19 25',
    data: '<path pid="0" d="M9.5 0c3.958 0 7.124 3.125 7.124 7.03v3.126c1.346 0 2.375 1.016 2.375 2.344L19 22.656C19 23.984 17.97 25 16.625 25H2.375C1.03 25 0 23.984 0 22.656V12.5c0-1.328 1.03-2.344 2.375-2.344V7.031C2.375 3.125 5.541 0 9.5 0zm7.916 12.5c0-.469-.317-.781-.791-.781H2.375c-.475 0-.792.312-.792.781v10.156c0 .469.317.781.792.781h14.249c.475 0 .792-.312.792-.781V12.5zM3.958 10.156h11.084V7.031c0-3.048-2.455-5.47-5.542-5.47-3.088 0-5.542 2.423-5.542 5.47v3.125zM9.5 14.063c1.345 0 2.375 1.015 2.375 2.344a2.277 2.277 0 01-1.584 2.187v1.718c0 .47-.316.781-.791.781-.476 0-.792-.312-.792-.78v-1.72a2.277 2.277 0 01-1.584-2.186c0-1.329 1.03-2.344 2.376-2.344zm0 3.125c.475 0 .791-.313.791-.781 0-.47-.316-.782-.791-.782-.476 0-.792.313-.792.782 0 .469.316.781.792.781z" _fill="#203F6A" fill-rule="evenodd"/>'
  }
})
